// extracted by mini-css-extract-plugin
export default {"DhammaLayout":"DhammaLayout_DhammaLayout__ODgZl"};